import React from "react";
import PathOption from "../PathOption";
import PathOptionGroup from "../PathOptionGroup";

function PathBuilderOptionsOS({ t, options, handleOptionChange }) {
  return (
    <PathOptionGroup title={t("pathBuilder.categories.operatingSystem")}>
      <PathOption
        id="os-windows"
        label={t("pathBuilder.checkboxes.windows")}
        checked={options.osWindows}
        onChange={() => handleOptionChange("osWindows")}
        disabled={options.osMac || options.osLinux}
      />
      <PathOption
        id="os-mac"
        label={t("pathBuilder.checkboxes.mac")}
        checked={options.osMac}
        onChange={() => handleOptionChange("osMac")}
        disabled={options.osWindows || options.osLinux}
      />
      <PathOption
        id="os-linux"
        label={t("pathBuilder.checkboxes.linux")}
        checked={options.osLinux}
        onChange={() => handleOptionChange("osLinux")}
        disabled={options.osWindows || options.osMac}
      />
    </PathOptionGroup>
  );
}

export default PathBuilderOptionsOS;
